<template>
  <div>
    <div class="up-input-group">
      <up-textinput
        v-model="clipart_table.title"
        size="sm"
        label="Table Title"
        labelIcon="mdi mdi-alpha-t-box-outline"
      ></up-textinput>
    </div>
    <div class="columns is-multiline">
      <!-- {{clipart_table}} -->
      <div class="column is-12">
        <style-editor
          v-model="clipart_table.styles"
          title="Table"
          show_bg_color
          show_font_color
        ></style-editor>
      </div>
      <div class="column is-12">
        <p class="title is-5">
          Row
          <b-button
            @click="addRow"
            type="is-success"
            size="is-small"
            icon-left="plus"
          ></b-button>
        </p>
        <b-collapse
          class="card"
          animation="slide"
          v-for="(clip, index) of clipart_table.properties"
          :key="`Clip${index}`"
          :open="isRowOpen == index"
          @open="isRowOpen = index"
        >
          <template #trigger="props">
            <div class="card-header" role="button">
              <p class="card-header-title">{{ `Row ${index + 1}` }}</p>
              <a class="card-header-icon">
                <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
              </a>
            </div>
          </template>
          <div class="card-content">
            <div class="content">
              <b-button
                type="is-info"
                size="is-small"
                @click="
                  toggle_custom_layout_cl_drawer = !toggle_custom_layout_cl_drawer
                "
                >Toggle Clipart Drawer
              </b-button>
              <clipart-selector
                v-if="toggle_custom_layout_cl_drawer"
                @input="addClipartFromDrawer(index, $event)"
              ></clipart-selector>
              <div class="up-input-group">
                <div>
                  <up-textinput
                    v-model="clip.title"
                    size="sm"
                    label="Title"
                    labelIcon="mdi mdi-alpha-t-box-outline"
                  ></up-textinput>
                </div>
                <div>
                  <up-numberinput
                    v-model="clip.num_images"
                    size="sm"
                    label="Number of Images"
                    labelIcon="mdi mdi-alpha-i-box-outline"
                  ></up-numberinput>
                </div>
                <div>
                  <up-switch
                    v-model="clip.is_user_selectable"
                    label="Is User Selectable"
                    labelIcon="mdi mdi-alpha-s-box-outline"
                  ></up-switch>
                </div>
                <div v-if="clip && clip.is_user_selectable" class="">
                   <up-numberinput
                    v-model="clip.answer"
                    size="sm"
                    label="Answer"
                    labelIcon="mdi mdi-alpha-a-box-outline"
                  ></up-numberinput>
                </div>
              </div>
              <div class="columns is-multiline">
                <div class="column is-12">
                  <style-editor
                    v-model="clip.styles"
                    title="Cliparts"
                    show_bg_color
                    show_font_color
                  ></style-editor>
                </div>
              </div>
              <b-button
                @click="removeRow(index)"
                type="is-danger"
                size="is-small"
                icon-left="close"
              ></b-button>
            </div>
          </div>
        </b-collapse>
      </div>
      <div class="column is-12">
        <show-clipart-table :clipart_table="clipart_table"></show-clipart-table>
      </div>
    </div>
  </div>
</template>

<script>
import ShowClipartTable from "./ShowClipartTable.vue";
import { defaultClipartTableValue } from "./utils";
import { defaultClipartTablePropertyValue } from "./utils";
import StyleEditor from "@/components/Common/StyleEditor/StyleEditor";
import ClipartSelector from "@/components/Question/Clipart/ClipartSelector";
import UpTextinput from "../../UI/Inputs/UpTextinput.vue";

import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
import UpSwitch from "@/components/UI/Inputs/UpSwitch";

export default {
  name: "set-clipart-table",
  props: {
    value: {
      type: Object,
    },
  },
  components: {
    ShowClipartTable,
    StyleEditor,
    ClipartSelector,
    UpTextinput,
    UpNumberinput,
    UpSwitch
  },
  data() {
    return {
      toggle_custom_layout_cl_drawer: false,
      isRowOpen: null,
      clipart_table: this.value ? this.value : defaultClipartTableValue(),
    };
  },
  methods: {
    addRow() {
      this.clipart_table.properties.push(defaultClipartTablePropertyValue());
    },
    removeRow(index) {
      this.clipart_table.properties.splice(index, 1);
    },
    addClipartFromDrawer(index, clipart_obj) {
      this.clipart_table.properties[index].clipart = clipart_obj;
      this.$buefy.toast.open({
        message: "Added clipart to Clipart Table",
        type: "is-success",
      });
    },
  },
  watch: {
    clipart_table: {
      handler: function(new_val) {
        this.$emit("input", new_val);
      },
      deep: true,
    },
    value: {
      handler: function(new_val) {
        this.clipart_table = new_val;
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
